<ngb-alert [type]="type" class="notification-message alert alert-{{type}} animated {{animatingClass}}" (closed)="dismiss()" [dismissible]="! notification.options?.undoText">
	<span class="content" [innerHTML]="(notification.message | translate : notification.messageParams) | safe:'html'"></span>
	@if (notification.options?.undoText) {
		<button class="btn btn-link float-right" [translate]="notification.options?.undoText" (click)="notification.options?.undoAction()"></button>
	}
</ngb-alert>
